export const SET_CACHED_ACTIVITY_STATE = 'SET_CACHED_ACTIVITY_STATE'
export const SET_DETAIL_ACTIVITY_STATE = 'SET_DETAIL_ACTIVITY_STATE'
